export const PAYROLL_TYPES = {
    driver: 'DRIVER',
    helper: 'HELPER',
    maintenance: 'MAINTENANCE',

    bookKeeper: 'BOOK_KEEPER',
}


// WEBPACK FOOTER //
// ./src/app/contants/PAYROLL_TYPES.ts